import { render, staticRenderFns } from "./Tempo4g.vue?vue&type=template&id=60cbff0e"
import script from "./Tempo4g.vue?vue&type=script&lang=js"
export * from "./Tempo4g.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports